module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Hazel_TW.ef8d871b.png";